import { Empty, EmptyProps } from "antd";

type PropsType = EmptyProps;

export const CustomEmpty = ({
  description = "Aucune donnée",
  ...props
}: PropsType) => {
  return <Empty description={description} {...props} />;
};
